"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _actions = require("./actions");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _LeaderboardListRow = _interopRequireDefault(require("./LeaderboardListRow"));

var _LeaderboardRowHeader = _interopRequireDefault(require("./shared/LeaderboardRowHeader"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 0.75rem;\n"])));

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      app = _ref.app,
      betbar = _ref.betbar,
      setBetbar = _ref.setBetbar,
      hidePrizeMoney = _ref.hidePrizeMoney,
      showPrizeIcons = _ref.showPrizeIcons;
  var dispatch = (0, _reactRedux.useDispatch)();
  var language = app.language;

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.leaderboard;
  }),
      activeUserBet = _useSelector.activeUserBet,
      isShowingMyBet = _useSelector.isShowingMyBet,
      userName = _useSelector.userName,
      userImage = _useSelector.userImage;

  var activePickem = betbar.activePickem,
      activeBet = betbar.activeBet,
      table = betbar.table,
      isBetbarLoading = betbar.isBetbarLoading;

  var handleRowClicked = function handleRowClicked(betId, activeUserBetId) {
    if (activePickem && activePickem.status === "APPROVED") {
      return;
    }

    if (betId !== activeUserBetId) {
      dispatch((0, _actions.getUsersBet)(betId));
    } else {
      dispatch((0, _actions.getUsersBet)(undefined));
    }
  };

  var isInPlay = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "IN_PLAY";
  var isCompleted = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "COMPLETED";
  var isPreMatchLeaderboard = !isInPlay && !isCompleted;
  console.log("isPreMatchLeaderboard", isPreMatchLeaderboard);
  var skeletonRows = new Array(20).fill(0);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: isShowingMyBet ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaderboardListRow.default, {
      hasTitle: true,
      translations: translations,
      isPreMatchLeaderboard: isPreMatchLeaderboard,
      isShowingMyBet: isShowingMyBet,
      isActive: true,
      activePickem: activePickem,
      row: {
        id: activeBet === null || activeBet === void 0 ? void 0 : activeBet.betId,
        points: activeBet === null || activeBet === void 0 ? void 0 : activeBet.points,
        prize: hidePrizeMoney ? undefined : activeBet === null || activeBet === void 0 ? void 0 : activeBet.prize,
        promoPrize: hidePrizeMoney ? undefined : activeBet === null || activeBet === void 0 ? void 0 : activeBet.promoPrize,
        rank: activeBet === null || activeBet === void 0 ? void 0 : activeBet.rank,
        user: {
          username: userName,
          image: userImage
        },
        selections: activeBet === null || activeBet === void 0 ? void 0 : activeBet.selections
      }
    }) : !table || isBetbarLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: skeletonRows.map(function (row, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaderboardRowHeader.default, {
            isSkeleton: true,
            index: index
          })
        });
      })
    }) : table.map(function (row, index) {
      if (hidePrizeMoney) {
        row.prize = undefined;
        row.promoPrize = undefined;
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaderboardListRow.default, {
        translations: translations,
        isDutch: language === "dutch",
        activePickem: activePickem,
        activeBet: activeBet,
        isPreMatchLeaderboard: isPreMatchLeaderboard,
        isShowingMyBet: isShowingMyBet,
        isActive: (activeUserBet === null || activeUserBet === void 0 ? void 0 : activeUserBet.betId) === (row === null || row === void 0 ? void 0 : row.betId) ? true : false,
        showPrizeIcons: showPrizeIcons,
        row: row,
        onRowClicked: function onRowClicked() {
          return handleRowClicked(row === null || row === void 0 ? void 0 : row.betId, activeUserBet === null || activeUserBet === void 0 ? void 0 : activeUserBet.betId);
        }
      });
    })
  });
};

var _default = Wrapper;
exports.default = _default;